export class ForgetPasswordResponseDTO{
    message: string = ''

    constructor(data: ForgetPasswordResponseDTO){
        Object.assign(this, data);
    }
}